/* eslint max-classes-per-file: 0 */

import {
  CollectorPublication as Data,
  CollectorPublicationCollection as Collection,
} from '@/typings/api/CollectorPublication'
import { SubjectsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class SubjectsTransformerParams extends TransformerParams {

}

export class SubjectsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new SubjectsTransformerParams();
}
